export default __webpack_public_path__ + "static/media/welcome_bg.25be9850.png";